export const BRANCH_BANKING_ID = {
  sefakoy_merkez: 'sefakoy-merkez',
  sefakoy_sube: 'sefakoy-sube',
  kavakli_sube: 'kavakli'
};

export const KNOWN_BRANCHES = [
  { key: 'sefakoy_merkez', label: 'Sefaköy Merkez' },
  { key: 'sefakoy_sube', label: 'Sefaköy Şube' },
  { key: 'kavakli_sube', label: 'Kavaklı Şube' }
];

export const BANK_PROVIDERS = {
  VAKIFBANK: 'vakifbank',
  GARANTI: 'garanti'
};

export const BANK_PROVIDER_LABELS = {
  [BANK_PROVIDERS.VAKIFBANK]: 'VakıfBank',
  [BANK_PROVIDERS.GARANTI]: 'Garanti BBVA'
};

/** Uygulama şube id (alt çizgili) → banka Firestore id (tireli). */
export const resolveBankingId = (appSube) =>
  BRANCH_BANKING_ID[String(appSube || '').trim()] || String(appSube || '').trim();

export const branchLabel = (key) =>
  KNOWN_BRANCHES.find((x) => x.key === key)?.label || String(key || '').replace(/_/g, ' ');

/** VakıfBank legacy paths (değişmez). */
export const bankStateDocPath = (bankingId) => `subeler/${bankingId}/bankState/current`;
export const bankMovementsCollectionPath = (bankingId) => `subeler/${bankingId}/bankMovements`;

/** Provider-scoped paths (Garanti ve gelecekteki bankalar). */
export const providerBankStateDocPath = (bankingId, provider) =>
  `subeler/${bankingId}/bankProviders/${provider}/bankState/current`;
export const providerBankMovementsCollectionPath = (bankingId, provider) =>
  `subeler/${bankingId}/bankProviders/${provider}/bankMovements`;

export const BANK_MOVEMENT_DIRECTIONS = {
  IN: 'in',
  OUT: 'out'
};

export const BANKING_SCHEMA_NOTE = {
  bankState: {
    currentBalance: 'number',
    availableBalance: 'number',
    currency: 'string',
    syncStatus: 'string',
    provider: 'vakifbank | garanti',
    bankName: 'string',
    iban: 'string',
    lastSyncAt: 'timestamp'
  },
  bankMovements: {
    amount: 'number',
    direction: 'in | out',
    currency: 'TRY',
    description: 'string',
    reference: 'string',
    externalTxId: 'string',
    bookingDate: 'timestamp',
    valueDate: 'timestamp',
    provider: 'string',
    bank: 'vakifbank | garanti',
    bankLabel: 'VakıfBank | Garanti BBVA',
    bankLogoKey: 'vakifbank | garanti',
    bankName: 'string',
    iban: 'string'
  },
  providerPaths: {
    bankState: 'subeler/{bankingId}/bankProviders/{provider}/bankState/current',
    bankMovements: 'subeler/{bankingId}/bankProviders/{provider}/bankMovements/{movementId}'
  }
};
